import React from "react";
import { withTranslation } from "react-i18next";
import get from "lodash/get";
import IconCorrect from "../../../static/images/IconCorrect.svg";
import IconWrong from "../../../static/images/IconWrong.svg";
import BrandRuleResult from "../../TouchPointView/BrandRuleResult";

const Question = ({ t, dailyQuest, marketGoal, strikes, answerQuestion, lblBrandRules, client }) => {
  const touchPoint = get(dailyQuest, "touchpointId", {});
  if (!touchPoint) {
    return null;
  }
  return (
    <div className="quest-content question">
      <div className="text-center">
        <div className="question-title">{t("dailyQuest.title")}</div>
      </div>
      {!!strikes && <div className="strikes-info">{t("dailyQuest.streakInfo", { count: strikes })}</div>}
      <div className="tp-info">
        <div className="tp-name">{touchPoint.name}</div>
      </div>
      <div className="m-auto" style={{ maxWidth: 500 }}>
        <BrandRuleResult
          t={t}
          index={0}
          item={marketGoal}
          marketGoalComment={""}
          checkedTrueMarketGoals={[]}
          checkedFalseMarketGoals={[]}
          markegGoalAudits={[]}
          profileId={null}
          showTitle={false}
          lblBrandRules={lblBrandRules}
          client={client}
        />
      </div>

      <hr />
      <div className="question-container">
        <div className="options-title">{t("dailyQuest.isFulfilledTitle", { lblBrandRules: lblBrandRules })}</div>
        <div className="options">
          <img onClick={() => answerQuestion(false)} src={IconWrong} alt="" />
          <img onClick={() => answerQuestion(true)} src={IconCorrect} alt="" />
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(Question);
